import Vue from "vue";
import { db, storageRef } from "@/firebase";
import firebase from "firebase/app";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
Vue.use(JSZip);

export const state = {
  expenses: [],
  isLoading: false
};
export const mutations = {
  ADD_EXPENSE(state, expenseData) {
    state.expenses.unshift(expenseData);
  },
  SET_STATUS(state, status) {
    state.isLoading = status;
  }
};
export const actions = {
  loadAllExpenses({ commit }) {
    if (state.expenses.length < 1) {
      // state.expenses = [];
      db.collection("expenses")
        .orderBy("creationDate", "asc")
        .onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            if (change.type === "added") {
              let tempExpense = {
                id: change.doc.id,
                ...change.doc.data()
              };
              commit("ADD_EXPENSE", tempExpense);
            }
          });
        });
    }
  },
  createNewExpense({ dispatch }, newExpense) {
    let metadata = {
      contentType: "image/jpeg"
    };
    let date = new Date();
    let ano = moment(date).format("YYYY");
    let month = date.getMonth() + 1;
    let tempData = Math.round(new Date().getTime() / 1000);
    let pasta = "";

    if (month >= 1 && month <= 3) {
      pasta = "01_03_" + ano;
    } else if (month >= 4 && month <= 6) {
      pasta = "04_06_" + ano;
    } else if (month >= 7 && month <= 9) {
      pasta = "07_09_" + ano;
    } else if (month >= 10 && month <= 12) {
      pasta = "10_12_" + ano;
    }

    var uploadTask = storageRef
      .child("faturas/" + pasta + "/" + tempData + newExpense.name)
      .put(newExpense, metadata);

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      function(snapshot) {
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED:
            break;
          case firebase.storage.TaskState.RUNNING:
            break;
        }
      },
      function(error) {
        switch (error.code) {
          case "storage/unauthorized":
            break;
          case "storage/canceled":
            break;
          case "storage/unknown":
            break;
        }
      },
      function() {
        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          let tempExpense = {
            creationDate: firebase.firestore.Timestamp.fromDate(new Date()),
            photoUrl: downloadURL
          };
          db.collection("expenses")
            .add(tempExpense)
            .then(() => {
              const notification = {
                type: "success",
                message: "New Expense added!"
              };
              dispatch("notification/add", notification, { root: true });
            })
            .catch(error => {
              const notification = {
                type: "error",
                message: "Something went wrong:" + error.message
              };
              dispatch("notification/add", notification, { root: true });
            });
        });
      }
    );
  },
  getExpensesRange({ dispatch, commit }, trimestre) {
    let storageName = "";
    let zip = new JSZip();
    let date = new Date();
    let img = zip.folder("images");
    let listAll = [];
    let promisses = [];
    let ano = moment(date).format("YYYY");

    commit("SET_STATUS", true);

    switch (trimestre) {
      case 1:
        storageName = "01_03_" + ano;
        break;
      case 2:
        storageName = "04_06_" + ano;
        break;
      case 3:
        storageName = "07_09_" + ano;
        break;
      case 4:
        storageName = "10_12_" + ano;
        break;
      default:
        storageName = "01_03_" + ano;
        break;
    }
    let storageRef = firebase.storage().ref("faturas/" + storageName);
    storageRef.listAll().then(result => {
      result.items.forEach(imageRef => {
        listAll.push(imageRef);
      });
      listAll.forEach((p, index) => {
        let promisse = new Promise((resolve, reject) => {
          p.getDownloadURL().then(x => {
            let xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = event => {
              resolve(xhr.response);
              img.file(storageName + "_" + index + ".png", xhr.response);
            };
            xhr.open("GET", x);
            xhr.send();
          });
        });
        promisses.push(promisse);
      });
      Promise.all(promisses).then(e => {
        if (e.length > 0) {
          zip.generateAsync({ type: "blob" }).then(
            content => {
              saveAs(content, storageName + ".zip");
              commit("SET_STATUS", false);
            },
            err => {
              console.log(err);
              commit("SET_STATUS", false);
            }
          );
        } else {
          commit("SET_STATUS", false);
        }
      });
    });
  }
};
export const getters = {
  getExpenses(state) {
    if (state.expenses != null) return state.expenses;
    else return null;
  },
  getLastExpenses(state) {
    if (state.expenses != null) {
      let expensesArray = [];
      for (let i = 0; i <= 2; i++) {
        if (state.expenses[i] != null) {
          expensesArray.push(state.expenses[i]);
        }
      }
      return expensesArray;
    }
  },
  getExpensesList(state) {
    let expensesArray = [];
    if (state.expenses != null) {
      if (state.expenses.length > 3) {
        for (let i = 3; i < state.expenses.length; i++) {
          expensesArray.push(state.expenses[i]);
        }
      }
      return expensesArray;
    }
  },
  getLoadingStatus(state) {
    return state.isLoading;
  }
};
